/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DocumentDownloadResponse
 */
export interface DocumentDownloadResponse {
  /**
   *
   * @type {string}
   * @memberof DocumentDownloadResponse
   */
  base64Data: string;
  /**
   *
   * @type {string}
   * @memberof DocumentDownloadResponse
   */
  contentType: string;
  /**
   *
   * @type {string}
   * @memberof DocumentDownloadResponse
   */
  filename: string;
  /**
   *
   * @type {string}
   * @memberof DocumentDownloadResponse
   */
  fileExtension: string;
}

/**
 * Check if a given object implements the DocumentDownloadResponse interface.
 */
export function instanceOfDocumentDownloadResponse(
  value: object,
): value is DocumentDownloadResponse {
  if (!("base64Data" in value) || value["base64Data"] === undefined)
    return false;
  if (!("contentType" in value) || value["contentType"] === undefined)
    return false;
  if (!("filename" in value) || value["filename"] === undefined) return false;
  if (!("fileExtension" in value) || value["fileExtension"] === undefined)
    return false;
  return true;
}

export function DocumentDownloadResponseFromJSON(
  json: any,
): DocumentDownloadResponse {
  return DocumentDownloadResponseFromJSONTyped(json, false);
}

export function DocumentDownloadResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DocumentDownloadResponse {
  if (json == null) {
    return json;
  }
  return {
    base64Data: json["base64Data"],
    contentType: json["contentType"],
    filename: json["filename"],
    fileExtension: json["fileExtension"],
  };
}

export function DocumentDownloadResponseToJSON(
  json: any,
): DocumentDownloadResponse {
  return DocumentDownloadResponseToJSONTyped(json, false);
}

export function DocumentDownloadResponseToJSONTyped(
  value?: DocumentDownloadResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    base64Data: value["base64Data"],
    contentType: value["contentType"],
    filename: value["filename"],
    fileExtension: value["fileExtension"],
  };
}
